import { lazy } from 'react'

export const CheckInboxV1 = lazy(() => import('./CheckInboxV1'))
